/*
 * @description:
 */

import type { CommodityPriceItemType, LatLonType, AddressType } from '../order-center/type';

// 从 order-center/type.ts 重新导出，保持兼容性
export type { LatLonType, AddressType };

// 其他需求 数据源类型
export type OtherRequireOptionType = {
  desc?: string;
  itemId?: string | null;
  name: string;
  priceType?: string | number;
  priceValueFen?: string | number;
  type: number | string;
  tooltip?: string;
};

// 备注下拉 数据源类型
export type OrderRemarkOptionType = {
  name: string;
  id: string | number;
  rank: string;
};

// 用车原由下拉 数据源类型
export type ReasonLabelListType = {
  id: string;
  content: string;
};

// 司机下拉 数据源类型
export type DriverListType = {
  driverFid: string; // 司机加密id？
  driverType: number; // 司机类型 2-众包 5-专送 
  name: string;
  photo: string;
  realDistanceMi: number; // 司机距离订单的距离，单位：米 排序用？
  realDistance: string; // 司机距离订单位置的提示。示例：“距发货地99米”
  licensePlate: string; // 车牌
  avgRating: string; // 评分
  isDisabled: boolean; // 是否禁用
  nameXing: string; // 姓氏
  isOnDuty: number;
};

/** 收藏司机列表接口 - 请求参数 */
export type GetFleetDriverListParams = {
  city_id: number;
  order_vehicle_id: number;
  /** 地址坐标，格式：lat|lon,lat|lon（gcj02） */
  order_lat_lon: string;
  std_tag: string[];
  page_no: number;
  page_size: number;
  /** 坐标系类型，固定传 gcj02 */
  coord_type: number;
  product_code_list: string[];
};

export type CouponType = {
  id: string;
  couponBizType: number; // //优惠类型:1-企业货运券 2-政府补贴 3-普通平台优惠(暂无)
  availablePay: number;
  availableTime: string; // 可用时间段
  businessTypeTag: string;
  cityName: string; // 适用范围，城市
  condition: number; // ?
  couponName: string; // 优惠券名称
  discount: string; // 优惠折扣值
  expTime: string; // 优惠有效期
  isAvailable: string |number; // 是否可用（0：否，1：是）
  maxDiscountFen: number; // 最大优惠金额值（分）
  preType: number; // 优惠分类（1：立减，2：折扣）
  preVal: number; // 实际优惠金额值（分）
  validEnd: string; // 适用结束时间戳
  vehicle: string; // 适用车型
  unavailableReason: string; // 不可用原因 todo
  showMore: boolean;
  isGovtSubsidy?: boolean; // 是否政府补贴券
};

export const defaultCoupon = (): CouponType => {
  return {
    id: '0', // 不使用券时传0
    couponBizType: 0, // 优惠类型:1-企业货运券 2-政府补贴 3-普通平台优惠(暂无)
    availablePay: 0,
    availableTime: '',
    businessTypeTag: '',
    cityName: '',
    condition: 0,
    couponName: '',
    discount: '',
    expTime: '',
    isAvailable: '',
    maxDiscountFen: 0,
    preType: 0,
    preVal: 0,
    validEnd: '',
    vehicle: '',
    unavailableReason: '',
    showMore: false,
  };
};

export type useGiftCardType = 0 | 1;
// 企业礼品卡
export type GiftCardType = {
  useGiftCard: useGiftCardType; // 是否使用礼品卡
};

// 礼品卡默认参数
export const defaultGiftCard = (): GiftCardType => {
  return {
    useGiftCard: 1,
  };
};

// 支付设置返回参数
export type PaywayConifgType = {
  // allowArrivalPay: boolean; // 是否支持到付
  // allowOwnAccount: boolean; // 是否支持自有账期
  // allowShareAccount: boolean; // 是否支持共享账期
  // allowWallet: boolean; // 是否支持钱包
  // allowWeChatPayOrAliPay: boolean; // 是否支持三方支付
  allowPayType: number[]; // 允许支付方式列表
  userSelectedPayType: number; // 用户选择的支付方式
  walletAvlBalanceFen: number | null; // 钱包余额
  walletBalanceLimitPrompt: string; // 钱包限制文案
  walletPrompt: string;
  accountAvlBalanceFen: number | null; // 月结余额
  accountBalanceLimitPrompt: string; // 月结限制文案
  needApproval: boolean; // 是否需要审批
  optionalAccountPay: number;
  optionalWalletPay: number;
  restrictArrivalPayReaseon: string;
};

// 支付设置函数入参
export type PaywayConfigParamsType = {
  finalPrice?: number;
  approvalPayType?: number;
  hitOnePrice?: number;
  commodityPriceList?: CommodityPriceItemType[];
  giftCardUseAmount?: number;
};

// 纸质回单送回方式（接口格式：1-开车送回，2-快递寄回）
export type ReceiptBackType = 1 | 2;

// 纸质回单数据类型（驼峰命名，内部使用）
export type PaperReceiptDataType = {
  receiptBackType?: ReceiptBackType | null;  // 送回方式：1-开车送回，2-快递寄回
  receiptAddrInfo?: AddressType | null;
};

// 纸质回单送回方式选项（用于表单选择，内部使用数字）
export const RETURN_METHOD_OPTIONS = [
  { value: 1 as const, label: '开车送回' },
  { value: 2 as const, label: '邮寄送回' },
];

// 纸质回单 type 值
export const PAPER_RECEIPT_TYPE = 3;
